import { EXECUTION_TEMPLATE } from "./execution-brief-template.enum";
import { BriefTemplateLabel } from "../brief-template-label.interface";

export const ExecutionBriefTemplateLabels: BriefTemplateLabel[] = [
  { label: "Branch", value: EXECUTION_TEMPLATE.DEALER_ADVERTISING },
  { label: "General", value: EXECUTION_TEMPLATE.EDM },
  { label: "InStore Digital", value: EXECUTION_TEMPLATE.INSTORE_DIGITAL },
  { label: "InStore Print", value: EXECUTION_TEMPLATE.INSTORE_PRINT },
  { label: "Paid Media", value: EXECUTION_TEMPLATE.PAID_MEDIA },
  { label: "Simple", value: EXECUTION_TEMPLATE.SIMPLE },
  { label: "Web", value: EXECUTION_TEMPLATE.WEB },
];
